import { defineField, defineType } from 'sanity'

export default defineType({
  name: 'ctaGrid',
  title: 'CTA Grid',
  type: 'object',
  fields: [
    defineField({
      name: 'heading',
      title: 'Heading',
      type: 'string',
    }),
    defineField({
      name: 'ctaList',
      title: 'CTA List',
      type: 'array',
      of: [
        {
          name: 'cta',
          title: 'CTA',
          type: 'object',
          fields: [
            defineField({
              name: 'heading',
              title: 'Heading',
              type: 'string',
              validation: (rule) => rule.required(),
            }),
            defineField({
              name: 'content',
              title: 'Content',
              type: 'text',
            }),
            defineField({
              name: 'action',
              title: 'Action',
              type: 'link',
            }),
          ],
        },
      ],
      validation: (rule) => [rule.required(), rule.min(1)],
    }),
    defineField({
      name: 'theme',
      type: 'sectionTheme',
    }),
  ],
  preview: {
    select: {
      title: 'heading',
    },
    prepare({ title }) {
      return {
        title,
        subtitle: 'CTA Grid',
      }
    },
  },
})